import React, { memo } from 'react';
import { useStyles } from './styles';

function Overlay() {
  const styles = useStyles();
  return <div className={styles.overlay} aria-label="subject overlay" />;
}

export default memo(Overlay);
